import { utils } from '@hh/global.js';
const { serializeForm } = utils;

if (!customElements.get('bis-form-wrapper')) {
  customElements.define(
    'bis-form-wrapper',
    class BISFormWrapper extends HTMLElement {
      constructor() {
        super();

        this.form?.addEventListener('submit', this.onSubmit.bind(this));
        this.error = this.querySelector('[data-error]');
        this.errorText = this.error.textContent;

        this.success = this.querySelector('[data-success]');
        this.successText = this.success.textContent;
      }

      onSubmit(event) {
        event.preventDefault();
        this.removeAttribute('error');
        const { Email, PhoneNumber, Sku, AlertCode } = JSON.parse(serializeForm(this.form));

        // Check if both Email and PhoneNumber are empty
        if (!Email && !PhoneNumber) {
          this.setAttribute('error', '');
          return; // Stop form submission if both fields are blank
        }

        if ((Email || PhoneNumber) && Sku && AlertCode && _ltk?.Alerts) {
          _ltk.Alerts.AddAlertWithIdentifiers({
            Identifiers: {
              Email,
              PhoneNumber,
            },
            Sku,
            AlertCode,
          });
          _ltk.Alerts.Submit();
          this.setAttribute('success', '');
          setTimeout(() => {
            this.removeAttribute('success');
          }, 3000);
        } else if (!_ltk) {
          console.error('The _ltk object is not defined.');
        }
      }

      // watch for error attribute changes
      static get observedAttributes() {
        return ['error', 'success'];
      }

      // handle error attribute changes
      // eslint-disable-next-line no-unused-vars
      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'error') {
          // eslint-disable-next-line no-console
          this.refreshErrorText();
        } else if (name === 'success') {
          // eslint-disable-next-line no-console
          // console.log('TODO: handle success logic');

          this.refreshSuccessText();
        }
      }

      // This make sure that the screen reader reads the error message
      refreshErrorText() {
        if (this.error.textContent === '') return;
        this.error.textContent = '';
        this.error.textContent = this.errorText;
      }

      refreshSuccessText() {
        if (this.success.textContent === '') return;
        this.success.textContent = '';
        this.success.textContent = this.successText;
      }

      get form() {
        return this.querySelector('form') || '';
      }
    },
  );
}
